module.exports = __webpack_public_path__ + "img/image-no-info.74b51155.png";